import { render, staticRenderFns } from "./healthList.vue?vue&type=template&id=41de66c0&scoped=true"
import script from "./healthList.vue?vue&type=script&lang=js"
export * from "./healthList.vue?vue&type=script&lang=js"
import style0 from "./healthList.vue?vue&type=style&index=0&id=41de66c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41de66c0",
  null
  
)

export default component.exports